import { useState } from "react";
import { supabase } from "./supabase";

export default function Auth() {
  const [mode, setMode] = useState("login"); // 'login' or 'signup'
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [clinicName, setClinicName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      if (mode === "signup") {
        // Sign up new clinic
        const { error } = await supabase.auth.signUp({
          email,
          password,
          options: {
            data: { clinic_name: clinicName },
          },
        });
        if (error) throw error;
        setMessage("✅ Account created! Please check your email to confirm.");
      } else {
        // Log in existing clinic
        const { error } = await supabase.auth.signInWithPassword({
          email,
          password,
        });
        if (error) throw error;
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const s = {
    wrap: { minHeight: "100vh", background: "linear-gradient(135deg, #1e3a5f 0%, #0f766e 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, fontFamily: "'Segoe UI', sans-serif" },
    card: { background: "#fff", borderRadius: 16, padding: "36px 32px", width: "100%", maxWidth: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" },
    logo: { textAlign: "center", marginBottom: 24 },
    logoIcon: { fontSize: 40 },
    logoTitle: { fontWeight: 800, fontSize: 22, color: "#1e3a5f", marginTop: 6 },
    logoSub: { fontSize: 12, color: "#64748b", marginTop: 2 },
    title: { fontWeight: 700, fontSize: 18, marginBottom: 20, color: "#1e293b" },
    label: { display: "block", fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 5 },
    input: { width: "100%", border: "1.5px solid #e2e8f0", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none", boxSizing: "border-box", marginBottom: 14 },
    btn: { width: "100%", background: "linear-gradient(135deg, #0f766e, #1e3a5f)", color: "#fff", border: "none", borderRadius: 10, padding: "13px", fontWeight: 700, fontSize: 15, cursor: "pointer", marginTop: 4 },
    toggle: { textAlign: "center", marginTop: 16, fontSize: 13, color: "#64748b" },
    toggleLink: { color: "#0f766e", fontWeight: 700, cursor: "pointer", textDecoration: "underline" },
    error: { background: "#fee2e2", color: "#991b1b", borderRadius: 8, padding: "10px 12px", fontSize: 13, marginBottom: 14 },
    success: { background: "#d1fae5", color: "#065f46", borderRadius: 8, padding: "10px 12px", fontSize: 13, marginBottom: 14 },
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        {/* Logo */}
        <div style={s.logo}>
          <div style={s.logoIcon}>🛡️</div>
          <div style={s.logoTitle}>HIPAA Comply</div>
          <div style={s.logoSub}>by Chenations LLC</div>
        </div>

        <div style={s.title}>
          {mode === "login" ? "Sign in to your account" : "Create your clinic account"}
        </div>

        {/* Error / Success Messages */}
        {error && <div style={s.error}>⚠️ {error}</div>}
        {message && <div style={s.success}>{message}</div>}

        {/* Clinic Name (signup only) */}
        {mode === "signup" && (
          <>
            <label style={s.label}>Clinic Name</label>
            <input
              style={s.input}
              type="text"
              placeholder="e.g. Greenfield Family Clinic"
              value={clinicName}
              onChange={e => setClinicName(e.target.value)}
            />
          </>
        )}

        {/* Email */}
        <label style={s.label}>Email Address</label>
        <input
          style={s.input}
          type="email"
          placeholder="admin@yourclinic.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        {/* Password */}
        <label style={s.label}>Password</label>
        <input
          style={s.input}
          type="password"
          placeholder="Minimum 6 characters"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSubmit()}
        />

        {/* Submit Button */}
        <button style={s.btn} onClick={handleSubmit} disabled={loading}>
          {loading ? "Please wait..." : mode === "login" ? "Sign In →" : "Create Account →"}
        </button>

        {/* Toggle Mode */}
        <div style={s.toggle}>
          {mode === "login" ? (
            <>Don't have an account?{" "}
              <span style={s.toggleLink} onClick={() => setMode("signup")}>Sign up free</span>
            </>
          ) : (
            <>Already have an account?{" "}
              <span style={s.toggleLink} onClick={() => setMode("login")}>Sign in</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}